<h3-toggle-button-group
  [buttons]="buttons"
  [formControl]="control"
  (buttonClick)="trackEvent('button')"
></h3-toggle-button-group>
